module.exports = __webpack_public_path__ + "img/logo_negativo.bf65c3e1.svg";